import { CustomFormAnswer, CustomFormTemplate } from "../../domain/CustomForm";
import { FileProps } from "../../shared/components/EditTicketAttachments/EditTicketAttachments";
import { AutomationOperators } from "../../shared/utils/constants";

export interface CustomForm {
  TemplateFormId: number,
  Name: string
  Order: number,
  SubmitButtonText: string,
  CardTemplateJson: CustomFormTemplate,
  CardAnswerJson: CustomFormAnswer,
  IsAnswered: boolean
}

export interface CustomFormState{
  isSendCurrentAnswers: boolean;
  customForms: CustomForm[],
  activeForm: CustomForm
  isSummaryPage: boolean,
  isCustomFormSaving: boolean
}
  
export const defaultCustomFormStateValue: CustomFormState = {
  isSendCurrentAnswers: true,
  customForms: null,
  activeForm: null,
  isSummaryPage: false,
  isCustomFormSaving: false
}

export interface CustomFormButtonState {
  showCancelButton: boolean
  showBackButton: boolean,
  showNextButton: boolean,
  showStartOverButton: boolean,
  showSubmitButton: boolean
}

export const defaultCustomFormButtonStateValue: CustomFormButtonState = {
  showCancelButton: true,
  showBackButton: false,
  showNextButton: false,
  showStartOverButton: false,
  showSubmitButton: true
}

export const nullOperators = [
  AutomationOperators.IsNull.toLowerCase(), 
  AutomationOperators.IsNotNull.toLowerCase(), 
  AutomationOperators.IsEmpty.toLowerCase(),
  AutomationOperators.IsNotEmpty.toLowerCase()
];

export interface CustomFormAttachmentsProps {
  TemplateFormId: number;
  Files: FileProps[];
  Message: string;
  IsPrivate: boolean;
}